module.exports = __webpack_public_path__ + "img/signal_wifi_1_bar_lock.66b14245.svg";